import { render, staticRenderFns } from "./myOrderPay.vue?vue&type=template&id=7fdb252d&scoped=true"
import script from "./myOrderPay.vue?vue&type=script&lang=js"
export * from "./myOrderPay.vue?vue&type=script&lang=js"
import style0 from "./myOrderPay.vue?vue&type=style&index=0&id=7fdb252d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdb252d",
  null
  
)

export default component.exports